<div *ngIf="false">
    Code: {{this.code}}
    State: {{this.state | json}}

    <div class="btn-primary" (click)="getToken()">
        Get Token
    </div>
</div>

<div *ngIf="response" class="p-3 w-100 text-center">
    Your account has been connected. You can close this page.
</div>